/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_PortalInputs */

const en_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const de_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const fr_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const es_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const it_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const nl_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const pl_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const fi_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const da_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

const sv_landing_tab_portal = /** @type {(inputs: Landing_Tab_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Scanner`)
};

/**
* | output |
* | --- |
* | "Portal Scanner" |
*
* @param {Landing_Tab_PortalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_portal = /** @type {((inputs?: Landing_Tab_PortalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_PortalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_portal(inputs)
	if (locale === "fr") return fr_landing_tab_portal(inputs)
	if (locale === "es") return es_landing_tab_portal(inputs)
	if (locale === "it") return it_landing_tab_portal(inputs)
	if (locale === "nl") return nl_landing_tab_portal(inputs)
	if (locale === "pl") return pl_landing_tab_portal(inputs)
	if (locale === "fi") return fi_landing_tab_portal(inputs)
	if (locale === "da") return da_landing_tab_portal(inputs)
	if (locale === "sv") return sv_landing_tab_portal(inputs)
	return en_landing_tab_portal(inputs)
});